<template>
  <component
    :is="isType"
    :href="url"
    :type="buttonIs"
    class="action-link"
    :disabled="disabled"
    @click="$emit('click')">
    <slot name="before"></slot>

    <slot>
      <span>{{ text }}</span>
    </slot>

    <slot name="after"></slot>
  </component>
</template>

<script>
export default {
  props: {
    isType: {
      type: String,
      default: 'button'
    },
    url: {
      type: String,
      default: undefined
    },
    buttonType: {
      type: String,
      default: 'button'
    },
    text: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    componentIs() {
      return this.isType !== 'a' ? 'button' : 'a'
    },
    buttonIs() {
      return this.isType === 'a' ? undefined : this.buttonType
    }
  }
}
</script>

<style lang="scss">
.action-link {
  @include reset-button;
  display: inline-flex;
  align-items: center;
  background-color: transparent;
  padding: 0;
}

.action-link > svg + span {
  margin-left: measure(quarter);
}
</style>
